import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useSelector } from "react-redux";
import ClinicScheduleModal from "../pages/schedulePage/ClinicScheduleModal";
import FullScreenSchedule from "../pages/schedulePage/FullScreenSchedule";
import QuickAddAppointmentModal from ".//QuickAddAppointmentModal";
import QuickAddClientModal from "./QuickAddClientModal";
import ResourceScheduleModal from "../pages/schedulePage/resourceComponents/ResourceScheduleModal";

const QuickAddModal = ({ onClose, activeModal }) => {
  const selectedClinic = useSelector((state) => state.clinics.selectedClinic);
  return (
    <>
      {activeModal === "client" && <QuickAddClientModal onClose={onClose} />}

      {activeModal === "appointment" && (
        <QuickAddAppointmentModal onClose={onClose} clinic={selectedClinic} />
      )}

      {activeModal === "schedule" && (
        <FullScreenSchedule
          isOpen={activeModal === "schedule"}
          onClose={() => onClose()}>
          <DndProvider backend={HTML5Backend}>
            <ClinicScheduleModal setModalOpen={onClose} />
          </DndProvider>
        </FullScreenSchedule>
      )}

      {activeModal === "resource" && (
        <FullScreenSchedule
          isOpen={activeModal === "resource"}
          onClose={() => onClose()}>
          <DndProvider backend={HTML5Backend}>
            <ResourceScheduleModal setModalOpen={onClose} />
          </DndProvider>
        </FullScreenSchedule>
      )}
    </>
  );
};

export default QuickAddModal;
